import { useEffect, useState } from 'react'
import { moment } from '../../../Components'

export const CORES = {
  primaria: '#273576',
  laranja: '#f48024',
  azul: '#3f6ad8',
  verde: '#13b88a',
  rosa: '#d92550',
  amarelo: '#f7b924',
  cinza: '#94a3b8',
}

export const PALETA = [CORES.primaria, CORES.laranja, CORES.azul, CORES.verde, CORES.rosa, CORES.amarelo, CORES.cinza]

export const formatarNumero = (valor) => Number(valor || 0).toLocaleString('pt-BR')

// Minutos → "12h 05min" (ou "45min")
export function formatarMinutos(minutos) {
  const total = Math.round(Number(minutos || 0))
  const horas = Math.floor(total / 60)
  const min = total % 60
  if (horas === 0) return `${min}min`
  return `${formatarNumero(horas)}h ${String(min).padStart(2, '0')}min`
}

// Eixo de minutos em horas inteiras, para não espremer o gráfico
export const formatarHoras = (minutos) => `${formatarNumero(Math.round(Number(minutos || 0) / 60))}h`

// Rótulos de data chegam da API como "yyyy-MM-dd" (dia no horário de Brasília)
export const formatarDia = (dia) => moment(dia, 'YYYY-MM-DD').format('DD/MM')
export const formatarDiaLongo = (dia) => moment(dia, 'YYYY-MM-DD').format('ddd, DD/MM/YYYY')

// Eixo X de dias: categorias em texto, rótulos espaçados quando o período é longo
export function eixoDias(dias, marcas = 10) {
  return {
    categories: dias,
    tickAmount: dias.length > 16 ? marcas : undefined,
    tickPlacement: 'on',
    labels: { rotate: 0, hideOverlappingLabels: true, formatter: (dia) => (dia ? formatarDia(dia) : '') },
    tooltip: { enabled: false },
  }
}

// Largura das colunas conforme a quantidade de dias (uma coluna só não ocupa o card inteiro)
export const larguraColuna = (qtdDias) => (qtdDias <= 3 ? '18%' : qtdDias > 20 ? '80%' : '50%')

// Eixo Y de contagem: só inteiros (com valores baixos o Apex gera 0,2 · 0,4 ...)
export function eixoContagem(valores, extra) {
  const maior = Math.max(0, ...valores)
  return {
    min: 0,
    max: maior < 5 ? Math.max(maior, 1) : undefined,
    tickAmount: maior < 5 ? Math.max(maior, 1) : 5,
    forceNiceScale: maior >= 5,
    labels: { formatter: (v) => formatarNumero(Math.round(v)) },
    ...extra,
  }
}

export const tooltipDias = { x: { formatter: (_, { dataPointIndex, w }) => formatarDiaLongo(w.config.xaxis.categories[dataPointIndex]) } }

// Carrega um indicador do Dashboard a cada mudança de filtro, descartando respostas de filtros anteriores
export function useIndicador(carregar, filters, semDados) {
  const [estado, setEstado] = useState({ status: 'loading', data: undefined })

  useEffect(() => {
    if (!filters) return
    let ativo = true
    setEstado({ status: 'loading', data: undefined })
    carregar(filters).then((data) => {
      if (ativo) setEstado({ status: !data || semDados(data) ? 'empty' : 'ok', data })
    })
    return () => {
      ativo = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return estado
}
